import type { PeopleSearchableAttributeOp } from '@customerio/hydra-ui-api';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { PEOPLE_SEARCH_OPERATOR_FAMILIES } from '../formats/people-filter/attribute-plugin';
import { peopleSearchableOperatorFamilies } from '../formats/people-filter/people-searchable';
import type { GroupableFamily } from '../operator-groups';

/**
 * The operator families an `AttributeFilterCondition` offers, for a search
 * that sends its condition to the customers endpoint.
 *
 * With `unified-condition-format-people` on, that endpoint validates the
 * condition against the `people_searchable` contract, so the offer is the
 * contract intersected with the caller's parity list. With it off, the offer
 * is the equality and existence families the endpoint has always taken.
 */
export function useAttributeFilterOperatorFamilies(
  parity: readonly PeopleSearchableAttributeOp[],
): readonly GroupableFamily[] {
  const isContractEnabled = useFeatureFlag(AccountFeatureFlag.UnifiedConditionFormatPeople);
  return isContractEnabled ? peopleSearchableOperatorFamilies('attribute', parity) : PEOPLE_SEARCH_OPERATOR_FAMILIES;
}
